import type { CSSProperties } from 'react'
import DashStatCard from '../../components/ui/DashStatCard'
import StatusBadge from '../../components/ui/StatusBadge'
import LineChart from '../../components/ui/LineChart'
import DashAvatar from '../../components/ui/DashAvatar'
import DashIcon from '../../components/ui/DashIcon'

const months  = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Aoû','Sep','Oct','Nov','Déc']
const revenue = [38000,42000,46000,52000,58000,64000,72000,78000,84000,92000,98000,108000]
const cost    = [22000,24500,26000,29000,32000,35000,38000,41000,44000,48000,51000,56000]

const codItems = [
  { label: 'Cash livreurs',       val: 48420, pct: 34, color: '#7CB342' },
  { label: 'Virements émis',      val: 62120, pct: 43, color: '#4FA0E8' },
  { label: 'En réconciliation',   val: 24180, pct: 17, color: '#F3A845' },
  { label: 'Litiges',             val: 8120,  pct: 6,  color: '#E5645A' },
]

type PayoutRow = [string, string, string, string, string, string, string, string]
const payouts: PayoutRow[] = [
  ['Youssef Karoui', 'Livreur',    '8–14 mai', '812.00',   '—',      '812.00',   'BIAT •••4821', 'pending'],
  ['Olive & Co.',    'Expéditeur', '8–14 mai', '7,840.50', '392.03', '7,448.47', 'BNA •••7102',  'pending'],
  ['Salma Mejri',    'Livreur',    '8–14 mai', '684.00',   '—',      '684.00',   'BH •••9213',   'pending'],
  ['Karaz Express',  'Expéditeur', '8–14 mai', '4,210.00', '210.50', '3,999.50', 'ATB •••2148',  'pending'],
  ['Karim Hammami',  'Livreur',    '8–14 mai', '738.50',   '—',      '738.50',   'STB •••6324',  'paid'],
]

export default function AdminFinances() {
  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Finances</h1>
          <p>Réconciliation COD, payouts livreurs, et P&L.</p>
        </div>
        <div className="ph-actions">
          <div className="seg">
            <button>Jour</button><button>Semaine</button>
            <button className="is-active">Mois</button><button>Année</button>
          </div>
          <button className="btn btn-ghost"><DashIcon name="download" size={14} /> Export comptable</button>
        </div>
      </div>

      <div className="stat-grid stat-grid-4" style={{ marginBottom: 18 }}>
        <DashStatCard label="Revenu (frais)"    value="98,420 DT"  trend="+18% vs avril"    icon="wallet" accent="green" spark={[3000,3500,4000,4800,5500,6200,7000,7800,8400,9200,9800,10400]} />
        <DashStatCard label="Coût livreurs"     value="51,240 DT"  trend="52% du revenu"    icon="helmet" accent="dark" />
        <DashStatCard label="COD en circulation" value="142,840 DT" trend="284 colis"        icon="cash" />
        <DashStatCard label="Marge brute"       value="47,180 DT"  trend="+24% vs an dernier" icon="chart" />
      </div>

      <div className="detail-grid" style={{ '--detail-cols': '1.4fr 1fr', gap: 18, marginBottom: 18 } as CSSProperties}>
        <div className="card chart-card">
          <div className="chart-head">
            <div className="totals">
              <div className="total"><span>Revenu</span><b>872k DT</b></div>
              <div className="total"><span style={{ color: 'var(--green-700)' }}>Marge</span><b style={{ color: 'var(--green-700)' }}>420k DT</b></div>
              <div className="total"><span style={{ color: 'var(--muted)' }}>Coûts</span><b style={{ color: 'var(--muted)' }}>452k DT</b></div>
            </div>
          </div>
          <div className="chart-body" style={{ height: 300 }}>
            <LineChart series={[{ data: revenue }, { data: cost }]} labels={months} height={300} />
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <h3>Réconciliation COD</h3>
            <span className="badge badge-amber">14 en attente</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {codItems.map((r, i) => (
              <div key={i} style={{ padding: '14px 0', borderTop: i ? '1px solid var(--line)' : '0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.85rem', marginBottom: 6 }}>
                  <span style={{ color: 'var(--navy-800)', fontWeight: 600 }}>{r.label}</span>
                  <span className="mono row-strong">{r.val.toLocaleString()} DT</span>
                </div>
                <div className="bar"><i style={{ width: r.pct + '%', background: r.color }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="tbl-card">
        <div className="tbl-toolbar">
          <h3 style={{ margin: 0, fontSize: '1rem' }}>Payouts à valider</h3>
          <span className="badge badge-amber" style={{ marginLeft: 8 }}>26 en attente</span>
          <div style={{ flex: 1 }} />
          <button className="btn btn-sm btn-ghost">Valider tout</button>
          <button className="btn btn-sm btn-primary">Exécuter virements</button>
        </div>
        <div className="tbl-scroll">
        <table className="tbl">
          <thead>
            <tr>
              <th>Bénéficiaire</th><th>Type</th><th>Période</th><th>Brut</th>
              <th>Frais</th><th>Net</th><th>RIB</th><th>Statut</th>
              <th className="col-actions">Action</th>
            </tr>
          </thead>
          <tbody>
            {payouts.map((r, i) => (
              <tr key={i}>
                <td><div className="cell-user"><DashAvatar name={r[0]} size={28} /><b>{r[0]}</b></div></td>
                <td><span className={`badge ${r[1] === 'Livreur' ? 'badge-green' : 'badge-blue'}`}>{r[1]}</span></td>
                <td style={{ color: 'var(--muted)' }}>{r[2]}</td>
                <td className="mono">{r[3]} DT</td>
                <td className="mono" style={{ color: 'var(--rose)' }}>{r[4] === '—' ? '—' : '-' + r[4] + ' DT'}</td>
                <td className="mono row-strong">{r[5]} DT</td>
                <td className="mono" style={{ fontSize: '.78rem', color: 'var(--muted)' }}>{r[6]}</td>
                <td><StatusBadge status={r[7]} /></td>
                <td className="col-actions">
                  {r[7] === 'paid'
                    ? <button>Reçu</button>
                    : <button style={{ background: 'var(--green-500)', color: '#fff' }}>Valider</button>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </>
  )
}
